import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import icons from '../icons';
import { cardClass } from './styles';
import { isRTL } from '../config';

var Header =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Header, _PureComponent);

  var _super = _createSuper2(Header);

  function Header() {
    _classCallCheck(this, Header);

    return _super.apply(this, arguments);
  }

  _createClass(Header, [{
    key: "renderIndicator",
    value: function renderIndicator() {
      var collapsed = this.props.collapsed;
      if (collapsed === undefined) return undefined;
      var className = cardClass('indicator');
      return (
        /*#__PURE__*/
        React.createElement("span", {
          className: className
        }, icons.AngleRight)
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          style = _this$props.style,
          align = _this$props.align,
          className = _this$props.className,
          children = _this$props.children,
          onCollapse = _this$props.onCollapse,
          collapsed = _this$props.collapsed;
      var newClassName = classnames(cardClass('header', align, isRTL() && 'header-rtl'), className);
      var onClick = typeof collapsed === 'boolean' ? onCollapse : undefined;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          style: style,
          onClick: onClick,
          className: newClassName
        }, this.renderIndicator(), children)
      );
    }
  }]);

  return Header;
}(PureComponent);

export default Header;